import { useTheme } from '../context/ThemeContext';

const LABELS = {
  system: 'Auto',
  light: 'Light',
  dark: 'Dark',
} as const;

const ICONS = {
  system: '🖥',
  light: '☀',
  dark: '☾',
} as const;

export function ThemeToggle() {
  const { theme, cycleTheme } = useTheme();
  return (
    <button
      className="theme-toggle"
      onClick={cycleTheme}
      title={`Theme: ${LABELS[theme]}. Click to cycle.`}
      aria-label={`Theme: ${LABELS[theme]}`}
    >
      <span aria-hidden="true">{ICONS[theme]}</span>
      <span className="theme-toggle-label">{LABELS[theme]}</span>
    </button>
  );
}
